import { LocationPageTemplate } from "@/components/LocationPageTemplate";

export default function TreptowKoepenick() {
  return (
    <LocationPageTemplate
      page={{
        location: "Treptow-Köpenick",
        locationSlug: "treptow-koepenick",
        keyword: "Haushaltsauflösung Treptow-Köpenick",
        metaTitle:
          "Haushaltsauflösung Treptow-Köpenick | Festpreis & Termin in 48h",
        metaDesc:
          "Professionelle Haushaltsauflösung in Berlin Treptow-Köpenick. Schnelle, diskrete und besenreine Haushaltsauflösung zum Festpreis. Kostenlose Besichtigung!",
        heroSub:
          "Ihre zuverlässige Haushaltsauflösung in Treptow-Köpenick – schnell, diskret und besenrein zum Festpreis.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/69909eeb36a39294293204c3.jpg",
        localIntro: (
          <>
            <p>
              Der wasser- und waldreichste Bezirk Berlins, Treptow-Köpenick,
              zeichnet sich durch eine sehr heterogene Bebauung aus. Während im
              Norden (Alt-Treptow, Plänterwald) dichtere städtische Strukturen
              und klassische Berliner Altbauten dominieren, prägen im Süden und
              Osten (Köpenick, Müggelheim, Rahnsdorf) weitreichende
              Einfamilienhaussiedlungen und Datschen das Bild.
            </p>
            <p>
              Diese Vielschichtigkeit erfordert bei der Haushaltsauflösung viel
              Erfahrung. In den Altbauquartieren sind enge Treppenhäuser und die
              Einrichtung von Halteverbotszonen oft die größte Herausforderung.
              In den weitläufigen Siedlungsgebieten am Wasser geht es hingegen
              häufig um die Räumung kompletter Grundstücke inklusive
              Nebengelassen, Kellern und Schuppen.
            </p>
            <p>
              Unser Team ist im gesamten Bezirk Treptow-Köpenick im Einsatz und
              bringt für jede Situation die passende Ausrüstung und Manpower
              mit, um Ihre Entrümpelung zügig und professionell abzuschließen.
            </p>
          </>
        ),
        trustText:
          "Ob eine Altbauwohnung in Treptow oder ein Haus am Wasser in Köpenick – wir nehmen Ihnen die schwere Arbeit ab und stehen Ihnen diskret zur Seite.",
        trustQuote:
          "Wirklich tolle Arbeit! Das Haus meiner Eltern in Köpenick wurde sehr schnell und gründlich geräumt.",
        challengesText: (
          <>
            <p>
              In den dichter bebauten Gebieten wie Alt-Treptow kümmern wir uns
              im Vorfeld um die Beantragung und Aufstellung von
              Halteverbotsschildern, um einen reibungslosen Abtransport zu
              gewährleisten.
            </p>
            <p>
              Bei der Räumung von Grundstücken in den wassernahen oder
              bewaldeten Gebieten sorgen wir für ausreichend Transportkapazität
              und kümmern uns um die fachgerechte Trennung und Entsorgung aller
              anfallenden Materialien, von Sperrmüll bis zu alten
              Gartenabfällen, auf den Berliner Recyclinghöfen.
            </p>
          </>
        ),
        reviews: [
          {
            text: "Sehr professionell und pünktlich. Die Wohnung in Alt-Treptow war danach komplett besenrein.",
            author: "Kunde aus Treptow",
          },
          {
            text: "Fairer Festpreis und sehr freundliche Mitarbeiter. Kann ich nur weiterempfehlen.",
            author: "Kundin aus Friedrichshagen",
          },
          {
            text: "Die Räumung des Hauses inklusive Garage ging schneller als gedacht. Top Leistung!",
            author: "Familie aus Köpenick",
          },
        ],
        neighbors: [
          { name: "Neukölln", slug: "neukoelln" },
          { name: "Marzahn-Hellersdorf", slug: "marzahn-hellersdorf" },
          { name: "Berlin", slug: "berlin" },
        ],
        faqs: [
          {
            q: "Räumen Sie auch Datschen oder Gartenlauben in Treptow-Köpenick?",
            a: "Ja, wir entrümpeln auch Wochenendhäuser, Gartenlauben und komplette Grundstücke im Bezirk.",
          },
          {
            q: "Was kostet eine Besichtigung?",
            a: "Die Besichtigung vor Ort zur Angebotserstellung ist bei uns immer kostenlos und unverbindlich.",
          },
          {
            q: "Wie lange im Voraus muss ich einen Termin vereinbaren?",
            a: "Wir können oft sehr flexibel reagieren. Besichtigungen sind meist innerhalb von 24-48 Stunden möglich, die Räumung kurz darauf.",
          },
          {
            q: "Verrechnen Sie auch Wertgegenstände?",
            a: "Ja, gut erhaltene Möbel, Antiquitäten oder Sammlungen können wir bei der Besichtigung bewerten und vom Preis abziehen.",
          },
        ],
      }}
    />
  );
}
